import { useFormik } from "formik";
import { Dialog } from "primereact/dialog";
import * as Yup from "yup";
import classes from "./Order.module.css";

const validationRules = {
  shipping_address: Yup.string().required("address is required"),
  shipping_state: Yup.string().required("State is required"),
  shipping_city: Yup.string().required("City is required"),
  shipping_zip: Yup.string()
    .matches(
      /^(?!([0-9])\1{5})[1-9][0-9]{5}$/,
      "Enter a valid 6-digit Indian pincode",
    )
    .required("Zip code is required"),
};

export default function AddAddress({
  open,
  setOpen,
  onSubmit,
  initialValues,
  shippingStates,
}) {
  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object(validationRules),
    onSubmit: async (values) => {
      onSubmit(values);
    },
  });

  const numberFilter = (event) => {
    const inputValue = event.target.value;

    const numericValue = inputValue.replace(/\D/g, "");
    formik.setFieldValue(event.target.name, numericValue);
  };

  return (
    <Dialog
      header="Add New Address"
      visible={open}
      onHide={() => {
        formik.resetForm();
        if (!open) return;
        setOpen(false);
      }}
      style={{
        width: "95vw",
        maxWidth: "600px",
        minWidth: "210px",
        minHeight: "400px",
      }}
      breakpoints={{
        "960px": "75vw",
        "641px": "90vw",
        "480px": "95vw",
      }}
      draggable={false}
      resizable={false}
    >
      <div className={classes.dialogContainer}>
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.formRow}>
            {/* Address */}
            <div className={classes.formColumn}>
              <label>
                Address:<span className="required">*</span>
              </label>
              <input
                id="shipping_address"
                type="text"
                name="shipping_address"
                className="form-control"
                placeholder="Enter address"
                value={formik.values.shipping_address}
                onChange={(event) => {
                  formik.setFieldValue("shipping_address", event.target.value);
                }}
              />
              {formik.touched.shipping_address &&
                formik.errors.shipping_address && (
                  <div className={classes.invalidDataError}>
                    {formik.errors.shipping_address}
                  </div>
                )}
            </div>

            {/* State */}
            <div className={classes.formColumn}>
              <label>
                State:<span className="required">*</span>
              </label>
              <select
                id="shipping_state"
                className="form-control"
                name="shipping_state"
                value={formik.values.shipping_state}
                onChange={(event) => {
                  formik.setFieldValue("shipping_state", event.target.value);
                }}
                onBlur={formik.handleBlur}
              >
                <option value="" disabled>
                  Select State
                </option>
                {shippingStates?.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
              {formik.touched.shipping_state &&
                formik.errors.shipping_state && (
                  <div className={classes.invalidDataError}>
                    {formik.errors.shipping_state}
                  </div>
                )}
            </div>

            {/* City */}
            <div className={classes.formColumn}>
              <label>
                City:<span className="required">*</span>
              </label>
              <input
                id="shipping_city"
                className="form-control"
                name="shipping_city"
                placeholder="Shipping City"
                value={formik.values.shipping_city}
                onChange={(event) =>
                  formik.setFieldValue("shipping_city", event.target.value)
                }
              />
              {formik.touched.shipping_city && formik.errors.shipping_city && (
                <div className={classes.invalidDataError}>
                  {formik.errors.shipping_city}
                </div>
              )}
            </div>

            {/* Zip Code */}
            <div className={classes.formColumn}>
              <label>
                Zip Code:<span className="required">*</span>
              </label>
              <input
                id="shipping_zip"
                name="shipping_zip"
                type="text"
                minLength={6}
                maxLength={6}
                className="form-control"
                placeholder="Shipping Zip"
                onChange={numberFilter}
                value={formik.values.shipping_zip}
              />
              {formik.touched.shipping_zip && formik.errors.shipping_zip && (
                <div className={classes.invalidDataError}>
                  {formik.errors.shipping_zip}
                </div>
              )}
            </div>
          </div>
          <div className={classes.buttonContainer}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setOpen(false)}
            >
              Close
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              onClick={formik.handleSubmit}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </Dialog>
  );
}
